import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import { STYLE_CLASSES } from "../../shared/constants/StyleConstants";
import {
  SERVICE_FILTERS_NAMES,
  SERVICE_TEMPLATES_ACCESS,
  SERVICE_TEMP_CONSTANTS,
  SERVICE_TEMP_FILTERS
} from "./constants/ServiceTemplateConstants";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import ScrollBottom from "../../shared/components/ScrollBottom/ScrollBottom.vue";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import ObservationModal from "@/shared/components/ObservationModal/ObservationModal.vue";
import ListItem from "@/shared/components/ListItem/ListItem.vue";
import {
  COLLECTIONS_NAME,
  COMPONENT_NAME_MODAL,
  FORM_CONSTANTS,
  FORM_MESSAGES,
  LIST_DATA_EVENTS,
  LOCAL_STORAGE
} from "../../shared/constants/FormConstants";
import { ServiceTemplatePagination } from "./models/ServiceTemplatePagination";
import { Response } from "@/shared/models/Response";
import { Http } from "@status/codes";
import { ServiceTemplateHeader } from "./models/ServiceTemplateHeader";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { QuerySendMultiple } from "../../shared/models/FormQuerySend";
import StepperViewer from "./components/StepperViewer/StepperViewer.vue";
import { ServiceTemplateService } from "./services/ServiceTemplateService";
import { ServiceTemplateModel } from "./models/ServiceTemplateModel";
import {
  GENERAL_CONSTANTS,
  PANEL_INFO_CONSTANTS,
  STATE,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";

import store from "@/store";
import { mapGetters } from "vuex";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import { Utils } from "@/shared/utils/utils";
import CrudChart from "@/shared/components/CrudChart/CrudChart.vue";
import { NavigationGuardNext, Route } from "vue-router";
import { SearchContext } from "@/shared/models/SearchContext";
import { Filter } from "../Dashboards/AdminDashboard/models/Filter";
import { ServiceTemplateMultiFilters } from "./models/ServiceTemplateMultiFilters.model";
import { CrudChartRenderData } from "../Dashboards/AdminDashboard/models/CrudChartRenderData";
import { CHART_INIT } from "@/shared/components/CrudChart/constants/CrudChartConstants";
import SaveServiceTemplate from "./components/SaveServiceTemplate/SaveServiceTemplate.vue";
import { ListService } from "../List/services/ListService";
import SaveCupsPriceLevel from "../CupsPriceLevels/components/SaveCupsPriceLevel/SaveCupsPriceLevel.vue";
import SaveSessionTemplate from "../SessionTemplate/components/SaveSessionTemplate/SaveSessionTemplate.vue";
import SaveFormTemplate from "../FormTemplate/components/SaveFormTemplate/SaveFormTemplate.vue";
import { AxiosError } from "axios";
import { LIST_ACCESS } from "../List/constants/ListConstants";

@Component({
  name: "ServiceTemplate",
  components: {
    EmptyState,
    ScrollBottom,
    ModalTemplate,
    ObservationModal,
    ListItem,
    StepperViewer,
    CrudChart,
    SaveServiceTemplate,
    SaveCupsPriceLevel,
    SaveSessionTemplate,
    SaveFormTemplate
  },
  computed: {
    ...mapGetters({
      dataToMainView: "getDataToMainView"
    })
  }
})
export default class ServiceTemplate extends Vue {
  @Inject() serviceTemplateService!: ServiceTemplateService;
  @Inject() listService!: ListService;

  dataToMainView!: MenuDataStructure;
  /* eslint-disable-next-line  @typescript-eslint/no-empty-function */
  callbackHandleContextPanel: Function = () => {};

  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  primaryBtnRoundClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;

  ADD_SERVICE_BTN = SERVICE_TEMP_CONSTANTS.BUTTON.ADD_SERVICE_TEXT;
  ADD_SESSION_BTN = SERVICE_TEMP_CONSTANTS.BUTTON.ADD_SESSION_TEXT;
  PAGE_TITLE = SERVICE_TEMP_CONSTANTS.TITLE.MAIN_TEMPLATE;
  OPERATIONS = [LIST_DATA_EVENTS.VIEW_DATA];
  CLICK_ACTION = LIST_DATA_EVENTS.EDIT_DATA;
  EMPTY_STATE = FORM_MESSAGES.INFO_MESSAGE;

  showCardsContainer = false;
  servicesList!: ServiceTemplateHeader[];
  dataServiceTemplate!: Response<ServiceTemplatePagination>;
  idReference = "";
  canSearch = true;
  dialogStepperViewer = false;
  componentStepperViewerKey = 0;
  cardClass = STYLE_CLASSES.CARD;

  serviceTemplateData: ServiceTemplateModel = new ServiceTemplateModel();

  filterItems: Filter[] = SERVICE_TEMP_FILTERS;
  serviceForm = null;
  admin = false;
  currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
  currentTooltip = SERVICE_TEMP_CONSTANTS.BUTTON.ADD_SERVICE_TEXT;
  querySearch?: QuerySendMultiple = {};
  categoriesGraphData: CrudChartRenderData = CHART_INIT;
  typesGraphData: CrudChartRenderData = CHART_INIT;
  statesGraphData: CrudChartRenderData = CHART_INIT;
  isLoadingCharts = false;
  showCharts = false;
  idServiceToEdit = "";
  showSaveServiceComponent = false;
  resetCupsModal = 0;
  resetFormModal = 0;
  showModalAddCups = false;
  showModalAddSession = false;
  showModalAddForm = false;
  serviceCategoryList: string[] = [];
  CUPS_MODAL = SERVICE_TEMP_CONSTANTS.LABEL.CUPS_MODAL;
  FORM_MODAL = SERVICE_TEMP_CONSTANTS.LABEL.FORM_MODAL;
  SESSION_MODAL = SERVICE_TEMP_CONSTANTS.LABEL.SESSION_MODAL;
  actionCancel = "";

  @Watch("dataToMainView")
  dataToMainViewHandler() {
    if (
      this.dataToMainView.from === PANEL_INFO_CONSTANTS.FROM.PANEL &&
      this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.SEARCH
    ) {
      switch (this.dataToMainView.action) {
        case PANEL_INFO_CONSTANTS.ACTION.DO_SEARCH_TEMPLATE:
          this.querySearch = this.dataToMainView.data;
          this.getDataCharts();
          break;
        case PANEL_INFO_CONSTANTS.ACTION.SHOW_CRUD_SAVE:
          this.onButtonAction();
          break;
        case PANEL_INFO_CONSTANTS.ACTION.DO_ON_BOTTOM_CONTEXT:
          this.sendDataToLateralMenu(
            PANEL_INFO_CONSTANTS.ACTION.LOADED_CONTEXT
          );
          break;
      }
    } else if (this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.OPTIONS) {
      if (
        this.dataToMainView.action ===
        SERVICE_TEMP_CONSTANTS.PANEL_OPTIONS_ACTIONS.CUPS
      ) {
        this.activeModalAddCups();
      } else if (
        this.dataToMainView.action ===
        SERVICE_TEMP_CONSTANTS.PANEL_OPTIONS_ACTIONS.FORM
      ) {
        this.activeModalAddForm();
      } else if (
        this.dataToMainView.action ===
        SERVICE_TEMP_CONSTANTS.PANEL_OPTIONS_ACTIONS.SESSION
      ) {
        this.activeModalAddSession();
      }
    }
  }

  sendDataToLateralMenu(action: string, data?: unknown) {
    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.CRUD,
      type: PANEL_INFO_CONSTANTS.TYPE.SEARCH,
      action: action,
      data: data
    });
  }

  fillListFilters() {
    this.filterItems[0].secondaryFilters[2].options = this.serviceCategoryList.map(
      item => ({
        key: item,
        name: item
      })
    );
  }

  async emitSearchInitializer() {
    const searchContext: SearchContext = {
      title: this.PAGE_TITLE,
      filterArray: this.filterItems,
      operations: this.OPERATIONS,
      clickAction: LIST_DATA_EVENTS.EDIT_DATA,
      callbackHandleOperation: this.handleOperation,
      descriptions: [SERVICE_FILTERS_NAMES.TYPE, SERVICE_FILTERS_NAMES.STATE],
      componentName: COMPONENT_NAME_MODAL.SERVICE_TEMPLATE,
      textButtonCreate: SERVICE_TEMP_CONSTANTS.BUTTON.ADD_SERVICE_TEXT
    };
    const data = searchContext;
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SEARCH_CONTEXT,
      data
    );
  }

  async mounted() {
    const views = localStorage.getItem(LOCAL_STORAGE.VIEWS);

    if (
      (JSON.parse(views as string) as string[]).includes(
        LOCAL_STORAGE.ADMIN_ROLE
      )
    ) {
      this.admin = true;
    }
    this.OPERATIONS = Utils.addExtraOperations(
      this.OPERATIONS,
      COLLECTIONS_NAME.SERVICE_TEMPLATE
    );

    await this.getServiceCategories();
    this.fillListFilters();
    this.emitSearchInitializer();
    this.getDataCharts();
    const serviceId = localStorage.getItem(LOCAL_STORAGE.SERVICE_ID);
    if (serviceId) {
      this.editService(serviceId);
      localStorage.removeItem(LOCAL_STORAGE.SERVICE_ID);
    }
  }

  async handleOperation(action: string, itemId: string) {
    switch (action) {
      case LIST_DATA_EVENTS.VIEW_DATA:
        await this.viewServiceMessage(itemId);
        break;
      case LIST_DATA_EVENTS.EDIT_DATA:
        this.editService(itemId);
        break;
      case LIST_DATA_EVENTS.DELETE_DATA:
        this.deleteServicetemp(itemId);
        this.closeComponent();
        break;
      case LIST_DATA_EVENTS.ACTIVE_DATA:
        this.updateStateServiceTemplate(itemId, STATE.ACTIVE);
        this.closeComponent();
        break;
      case LIST_DATA_EVENTS.DESACTIVED_DATA:
        this.updateStateServiceTemplate(itemId, STATE.INACTIVE);
        this.closeComponent();
        break;
      case LIST_DATA_EVENTS.CANCEL_DATA:
        this.closeComponent();
        break;
    }
  }

  closeComponent() {
    switch (this.actionCancel) {
      case this.CUPS_MODAL:
        this.showModalAddCups = false;
        this.resetCupsModal = 1 - this.resetCupsModal;
        break;
      case this.SESSION_MODAL:
        this.showModalAddSession = false;
        break;
      case this.FORM_MODAL:
        this.showModalAddForm = false;
        this.resetFormModal = 1 - this.resetFormModal;
        break;
      default:
        this.currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
        this.currentTooltip = SERVICE_TEMP_CONSTANTS.BUTTON.ADD_SERVICE_TEXT;
        this.PAGE_TITLE = SERVICE_TEMP_CONSTANTS.TITLE.MAIN_TEMPLATE;
        this.idServiceToEdit = "";
        this.showSaveServiceComponent = false;
        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM_NULL,
          { showOptions: this.showSaveServiceComponent }
        );
        break;
    }
  }

  async updateStateServiceTemplate(id: string, state: string) {
    try {
      const responseData = await this.serviceTemplateService.updateStateServiceTemplateById(
        id,
        state
      );
      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(SERVICE_TEMP_CONSTANTS.DIALOG_MESSAGE.UPDATE);
        await this.getDataCharts();
      } else Snackbar.popError(responseData.message);
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + SERVICE_TEMPLATES_ACCESS.PUT
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  editService(serviceId: string) {
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM,
      serviceId
    );
    this.currentIcon = GENERAL_CONSTANTS.ICONS.CANCEL;
    this.currentTooltip = FORM_CONSTANTS.BUTTON.CANCEL;
    this.PAGE_TITLE = SERVICE_TEMP_CONSTANTS.TITLE.EDIT_TEMPLATE;
    this.idServiceToEdit = serviceId;
    this.showSaveServiceComponent = true;
  }

  async viewServiceMessage(serviceTemplateId: string) {
    try {
      const response = await this.serviceTemplateService.getServiceTemplateById(
        serviceTemplateId
      );

      if (response.code === Http.Found && response.data != null) {
        this.componentStepperViewerKey++;
        this.serviceTemplateData = response.data;
        this.dialogStepperViewer = true;
      } else {
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + SERVICE_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  closeStepperViewer() {
    this.dialogStepperViewer = false;
  }

  async deleteServicetemp(id: string) {
    try {
      const responseData = await this.serviceTemplateService.deleteServiceTemp(
        id
      );

      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(responseData.message);
        this.showSaveServiceComponent = false;
        this.currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
        this.currentTooltip = SERVICE_TEMP_CONSTANTS.BUTTON.ADD_SERVICE_TEXT;
        await this.getDataCharts();
      } else Snackbar.popError(responseData.message);
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + SERVICE_TEMPLATES_ACCESS.DELETE
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.DISABLE_SEARCH_CONTEXT
    );
    next();
  }

  onButtonAction() {
    if (
      this.currentTooltip === SERVICE_TEMP_CONSTANTS.BUTTON.ADD_SERVICE_TEXT
    ) {
      this.showSaveServiceComponent = true;
      this.currentIcon = GENERAL_CONSTANTS.ICONS.CANCEL;
      this.currentTooltip = FORM_CONSTANTS.BUTTON.CANCEL;
      this.PAGE_TITLE = SERVICE_TEMP_CONSTANTS.TITLE.ADD_TEMPLATE;
      this.idServiceToEdit = "";
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM_NULL,
        { showOptions: this.showSaveServiceComponent }
      );
      store.commit(STORE_CONSTANTS.CAMPUS_SERVICE_TEMPLATE, true);
    } else {
      this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.MODAL_CANCEL);
      store.commit(STORE_CONSTANTS.CAMPUS_SERVICE_TEMPLATE, false);
    }
  }

  async getDataCharts() {
    try {
      this.isLoadingCharts = true;

      const filterQuery: ServiceTemplateMultiFilters = { chartData: true };

      if (this.querySearch?.name) {
        filterQuery.internalName = this.querySearch.name[0];
      }

      if (this.querySearch?.category) {
        filterQuery.categoriesList = this.querySearch.category;
      }

      if (this.querySearch?.state) {
        filterQuery.statesList = this.querySearch.state;
      }

      if (this.querySearch?.type) {
        filterQuery.typesList = this.querySearch.type;
      }

      const response = await this.serviceTemplateService.getDataChart(
        filterQuery
      );

      if (response.code === Http.Found && response.data !== undefined) {
        this.statesGraphData = {
          chartTitle: SERVICE_TEMP_CONSTANTS.LABEL.CHARTS.STATE,
          chartRenderData: Utils.mapChartData(
            response.data.chartData,
            SERVICE_FILTERS_NAMES.STATE
          )
        };
        this.categoriesGraphData = {
          chartTitle: SERVICE_TEMP_CONSTANTS.LABEL.CHARTS.CATEGORY,
          chartRenderData: Utils.mapChartData(
            response.data.chartData,
            SERVICE_FILTERS_NAMES.CATEGORY
          )
        };
        this.typesGraphData = {
          chartTitle: SERVICE_TEMP_CONSTANTS.LABEL.CHARTS.TYPE,
          chartRenderData: Utils.mapChartData(
            response.data.chartData,
            SERVICE_FILTERS_NAMES.TYPE
          )
        };

        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
          response.data.serviceTmpArray
        );

        this.showCharts = true;
      } else {
        Snackbar.popError(response.message);
        this.showCharts = false;
        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.RESET_SEARCH_CONTEXT
        );
      }

      this.isLoadingCharts = false;
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + SERVICE_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      this.showCharts = false;
    }
  }

  cancel() {
    this.showSaveServiceComponent = false;
    this.idServiceToEdit = "";
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM_NULL,
      { showOptions: this.showSaveServiceComponent }
    );
    this.PAGE_TITLE = SERVICE_TEMP_CONSTANTS.TITLE.MAIN_TEMPLATE;
    this.currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
    this.currentTooltip = SERVICE_TEMP_CONSTANTS.BUTTON.ADD_SERVICE_TEXT;
  }

  activeModalAddCups() {
    this.showModalAddCups = true;
  }

  activeModalAddForm() {
    this.showModalAddForm = true;
  }

  activeModalAddSession() {
    this.showModalAddSession = true;
  }

  closeServiceForm() {
    this.showSaveServiceComponent = false;
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM_NULL,
      { showOptions: this.showSaveServiceComponent }
    );
    this.currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
    this.currentTooltip = SERVICE_TEMP_CONSTANTS.BUTTON.ADD_SERVICE_TEXT;
    this.PAGE_TITLE = SERVICE_TEMP_CONSTANTS.TITLE.MAIN_TEMPLATE;
    this.getDataCharts();
  }

  chartStateClick(label: string) {
    // eslint-disable-next-line  @typescript-eslint/no-non-null-assertion
    this.querySearch!.state = [label];
    this.getDataCharts();
  }

  chartStateClickOut() {
    delete this.querySearch?.state;
    this.getDataCharts();
  }

  chartCategoryClick(label: string) {
    // eslint-disable-next-line  @typescript-eslint/no-non-null-assertion
    this.querySearch!.category = [label];
    this.getDataCharts();
  }

  chartCategoryClickOut() {
    delete this.querySearch?.category;
    this.getDataCharts();
  }

  chartTypeClick(label: string) {
    // eslint-disable-next-line  @typescript-eslint/no-non-null-assertion
    let typeLabel = "";
    if (label === SERVICE_TEMP_CONSTANTS.TYPE_SHOW.GROUPS) {
      typeLabel = SERVICE_TEMP_CONSTANTS.TYPE.GROUPS;
    } else if (label === SERVICE_TEMP_CONSTANTS.TYPE_SHOW.SECTIONS) {
      typeLabel = SERVICE_TEMP_CONSTANTS.TYPE.SECTIONS;
    }
    this.querySearch!.type = [typeLabel];
    this.getDataCharts();
  }

  chartTypeClickOut() {
    delete this.querySearch?.type;
    this.getDataCharts();
  }

  closeOnSave() {
    this.showModalAddCups = false;
    this.resetCupsModal = 1 - this.resetCupsModal;
  }

  closeAddFormOnSave() {
    this.showModalAddForm = false;
    this.resetFormModal = 1 - this.resetFormModal;
  }

  closeOptionsModal(componentName: string) {
    this.actionCancel = componentName;
    if (componentName !== this.SESSION_MODAL) {
      this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.MODAL_CANCEL, {
        componentName
      });
    } else {
      this.showModalAddSession = false;
    }
  }

  async getServiceCategories() {
    try {
      const responseData = await this.listService.getListOptionsByName(
        SERVICE_TEMP_CONSTANTS.CATEGORY_LIST_NAME
      );

      if (responseData.code === Http.Found && responseData.data) {
        this.serviceCategoryList = responseData.data.map(
          option => option.title
        );
      } else {
        Snackbar.popInfo(
          SERVICE_TEMP_CONSTANTS.SNACKBAR_MESSAGES.CATEGORIES_NOT_FOUND
        );
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }
}
